import WritingTestInstructions from "./WritingTestInstructions.js";
import SpeakingTestInstructions from "./SpeakingTestInstructions.js";

export const instructionRegistry = {
    writing: WritingTestInstructions,
    speaking: SpeakingTestInstructions,
};
